import './App.css';
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import {TextField, Button, Drawer} from '@mui/material';
import { List, ListItem  } from '@mui/material';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

var fontSize = 0;
const FontEqualizer = () => {
  const [screenWidth, setScreenWidth] = useState(0)

  useEffect(() => {
    const updateFontSize = () => {
      const widthProportion = window.innerWidth * 0.0085
      const height = window.innerHeight  * 0.0085
      if (height > widthProportion){
        setScreenWidth(widthProportion*2);
      }else{
        setScreenWidth(widthProportion);
      }
    };

    updateFontSize();
    window.addEventListener('resize', updateFontSize);

    return () => window.removeEventListener('resize', updateFontSize);
  }, []);

  if(!fontSize || window.innerWidth > window.innerHeight){
    return screenWidth
  }else {
    return fontSize
  }
}

function App() {
  fontSize = FontEqualizer()

  return (
    <>
      <BrowserRouter>
      <div className='container'>
        <NightSky/>
        <div className='home' id="home">
          <img src={require("./assets/moon.png")}/>
          <h1  style={{fontSize: `${fontSize*((window.innerHeight > window.innerWidth)? 7 : 11)}px`}}>Reach for the stars.</h1>
        </div>
        <Routes>
            <Route path="/" element={<Both/>} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
        </Routes>
        <Contact/>
      </div>
      </BrowserRouter>
    </>
  );
}

const Nav = ({setPage, page}) => {

  const fontSize = FontEqualizer()
  const [navSize, setNavSize] = useState("")

  useEffect(()=> {
      const handleScroll = () => {
         let p = window.scrollY
          setNavSize((p > 40) ? "wide" : (navSize === "wide" || navSize === "thin") ? "thin" : "")
      };
      window.addEventListener("scroll", handleScroll);
      return(() => {
         window.removeEventListener("scroll", handleScroll);
      })
  })

  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <div className={'nav ' + navSize}>
      <HashLink to="#home"><div className='image'/></HashLink>
      {(window.innerHeight > window.innerWidth) && <img alt="menu icon" className='hamburger' onClick={toggleDrawer} src={require('./assets/menu.png')}/>}
      {(window.innerHeight <= window.innerWidth) && <div className="links" style={{fontSize: `${fontSize*1.3}px`}}>
      <HashLink className={(page == "websites") ?"clicked" : ""} onClick={()=>{setPage("websites")}} to="#top">Websites I Made</HashLink>
        <HashLink className={(page == "apps") ?"clicked" : ""} onClick={()=>{setPage("apps")}} to="#top">Apps I Created</HashLink>
        <HashLink to="#contact">Reach Out To Me</HashLink>
      </div>}
      <Drawer anchor="left" open={open} onClose={toggleDrawer}>
          <List  className='drawer'>
            <ListItem>
              <p><HashLink onClick={()=>{ toggleDrawer()}} to="#home">Go Back Home</HashLink></p>
            </ListItem>
            <ListItem>
              <p><HashLink className={(page == "websites") ?"clicked" : ""} onClick={()=>{ toggleDrawer(); setPage("websites")}} to="#top">Websites I Made</HashLink></p>
            </ListItem>
            <ListItem>
              <p><HashLink className={(page == "apps") ?"clicked" : ""} onClick={()=>{ toggleDrawer(); setPage("apps")}} to="#top">Apps I Created</HashLink></p>
            </ListItem>
            <ListItem>
              <p><HashLink onClick={()=>{ toggleDrawer()}} to="/#contact">Reach Out To Me</HashLink></p>
            </ListItem>

          </List>
        </Drawer>
    </div>
  )
}

const Both = () => {
  const [page, setPage] = useState("websites")
  return(
    <>
    <Nav setPage={setPage} page={page}/>
    <div className='both' id="top">
      {page == "websites" && <Websites/>}
      {page == "apps" && <Apps/>}
    </div>
    </>
  )
}

const useAppleDevice = () => {
  const [isAppleDevice, setIsAppleDevice] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const applePlatforms = /(iphone|ipad|ipod|mac)/;

    setIsAppleDevice(applePlatforms.test(userAgent));
  }, []);

  return isAppleDevice;
};

const Apps = () => {
  const isApple = useAppleDevice();
  return (
    <div className='apps'>
      <div className='app'>
          <a href={(isApple) ? "https://apps.apple.com/" : "https://play.google.com/store/apps/details?id=com.StupidSimpleSoftware.LyricLab"} target='_blank'><img src={require('./assets/apps/normalscreenshot1.jpg')}/></a>
          <a href={(isApple) ? "https://apps.apple.com/" : "https://play.google.com/store/apps/details?id=com.StupidSimpleSoftware.LyricLab"} target='_blank'><img src={require('./assets/apps/normalscreenshot2.jpg')}/></a>
          <a href={(isApple) ? "https://apps.apple.com/" : "https://play.google.com/store/apps/details?id=com.StupidSimpleSoftware.LyricLab"} target='_blank'><img src={require('./assets/apps/normalscreenshot3.jpg')}/></a>
          <a href={(isApple) ? "https://apps.apple.com/" : "https://play.google.com/store/apps/details?id=com.StupidSimpleSoftware.LyricLab"} target='_blank'><img src={require('./assets/apps/normalscreenshot4.jpg')}/></a>
          {/* <img src={require('./assets/apps/splitscreenshot.jpg')}/> */}
      </div>
    </div>
  )
}


const Websites = () => {
  return (
    <div className='websites'>
      <div className='website'>
        {/* <div className='content'>
          <h1>Bungalow Lakehouse</h1>
        </div> */}
        <a href="http://bungalowlakehouse.netlify.app" target='_blank'><img src={require('./assets/websites/bungalowlakehouse'+ ((window.innerHeight > window.innerWidth) ? "mobile": "") +'.jpg')}/></a>
      </div>
      <div className='website'>
        <a href="http://www.bondedbirths.com" target='_blank'><img src={require('./assets/websites/bondedbirths'+ ((window.innerHeight > window.innerWidth) ? "mobile": "") +'.jpg')}/></a>
      </div>
      <div className='website'>
        <a href="http://comedybungalow.netlify.app" target='_blank'><img src={require('./assets/websites/comedybungalow'+ ((window.innerHeight > window.innerWidth) ? "mobile": "") +'.jpg')}/></a>
      </div>
      <div className='website'>
        <a href="http://www.ocd-organizing.com" target='_blank'><img src={require('./assets/websites/ocdorganizing'+ ((window.innerHeight > window.innerWidth) ? "mobile": "") +'.jpg')}/></a>
      </div>
    </div>
  )
}

const Contact = () => {
  const [phoneNum, setPhoneNum] = useState("")

  const setPhoneNumber = (e) => {
    let formattedNumber;
    const { name, value } = e.target;
    const { length } = value;
    // Filter non numbers
    const regex = () => value.replace(/[^0-9\.]+/g, "");
    // Set area code with parenthesis around it
    const areaCode = () => `(${regex().slice(0, 3)})`;

    // Set formatting for first six digits
    const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;

    // Dynamic trail as user types
    const trailer = (start) => `${regex().slice(start,
    regex().length)}`;
      if (length < 3) {
        // First 3 digits
        formattedNumber = regex();
      } else if (length === 4) {
        // After area code
        formattedNumber = `${areaCode()} ${trailer(3)}`;
      } else if (length === 5) {
        // When deleting digits inside parenthesis
        formattedNumber = `${areaCode().replace(")", "")}`;
      } else if (length > 5 && length < 9) {
        // Before dash
        formattedNumber = `${areaCode()} ${trailer(3)}`;
      } else if (length >= 10) {
        // After dash
        formattedNumber = `${firstSix()}-${trailer(6)}`;
      }
    const formattedObject = {
      target: { name: name, value: formattedNumber }
    };
    setPhoneNum(formattedNumber)
  }

  return (
    <div className='contact' id="contact">
      <div className='formContainer'>
        <div><h1 style={{fontSize: `${fontSize*5}px`}}>Reach Out To Me</h1><a href="mailto:onebytewonders@gmail.com"><img src={require('./assets/email.png')}/></a></div>
        <form name="contact" method="POST" >
          <input type="hidden" name="form-name" value="contact"/>
          <TextField
          inputProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, backgroundColor: '#191e27', color: "white"}}}
          InputLabelProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, color: "#999"}}}
          className='formItem short' required label="What's your name?" name="name" margin="dense"
          sx={{'& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#dfb31e'},
            '&.Mui-focused fieldset': { borderColor: '#dfb31e'}},

          }}/>
          <TextField
          inputProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, backgroundColor: '#191e27', color: "white"}}}
          InputLabelProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, color: "#999"}}}
          className='formItem short' required label="What's your e-mail?" name="email" type="email" margin="dense"
          sx={{'& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#dfb31e'},
            '&.Mui-focused fieldset': { borderColor: '#dfb31e'}},

          }}/>
          <TextField
          inputProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, backgroundColor: '#191e27', color: "white"}}}
          InputLabelProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, color: "#999"}}}
          className='formItem short' required label="What's your phone number?" name="phone" type="tel" margin="dense" onChange={(v)=>setPhoneNumber(v)} value={phoneNum}
          sx={{'& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#dfb31e'},
            '&.Mui-focused fieldset': { borderColor: '#dfb31e'}},

          }}/>
          <TextField
          inputProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, backgroundColor: '#191e27', color: "white"}}}
          InputLabelProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, color: "#999"}}}
          className='formItem' required label="How did you hear about me?" name="reference"  margin="dense"
          sx={{'& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#dfb31e'},
            '&.Mui-focused fieldset': { borderColor: '#dfb31e'}},

          }}/>
          <TextField
          rows={3} multiline
          inputProps={{style: {fontSize: `${fontSize*1}px`}}}
          InputLabelProps={{style: {fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`, color: "#999"}}}
          className='formItem' required label="What can I do for you?" name="message"  margin="dense"
          sx={{'& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#dfb31e'},
            '&.Mui-focused fieldset': { borderColor: '#dfb31e'}},

            '& .MuiInputBase-root': {backgroundColor: '#191e27', color: "white"}
          }}/>
          <Button className='formItem button' type="submit" variant="contained"
          sx={{ fontSize: `${fontSize*((window.innerHeight > window.innerWidth)?1.8: 1)}px`,color: '#000',backgroundColor: '#dfb31e', marginTop: '3%', marginBottom: '1%'   }} >
            Send
          </Button>
        </form>
      </div>
    </div>
  )
}


function Star({ x, y, size, delay }) {
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setOpacity(Math.random() * 0.5 + 0.5);
    }, Math.random() * 500 + 500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className="star"
      style={{
        left: `${x}%`,
        top: `${y}%`,
        width: `${size}px`,
        height: `${size}px`,
        opacity: opacity,
        animationDelay: `${delay}s`,
      }}
    />
  );
}

function NightSky() {

  // TODO if the nightsky is too cpu intensive, maybe make 2 or 3 background that
  // have random dots and have them pulse at different rates and overlap,
  // so that way you just render 3 images instead of having to do so many animations
  const stars = [];

  // TODO
  // 700 for each 100vh, 700 (home) + 700 (contact) + 700 * (# apps/websites)
  // var numberOfStars = (location.pathname == "/apps")?  2800 : 4200;
  for (let i = 0; i < 250; i++) {
    const x = Math.random() * 100;
    const y = Math.random() * 100;
    const size = Math.random() * 10 + 1;
    const delay = Math.random() * 4;

    stars.push(
      <Star key={i} x={x} y={y} size={size} delay={delay} />
    );
  }

  return (
    <div className="night-sky">
      {stars}
    </div>
  );
}


const PrivacyPolicy = () => {
  return(
    <div className="document">
    <h1>Privacy Policy</h1>

<p>This privacy policy applies to the Lyric Lab app (hereby referred to as "Application") for mobile devices that was created by OneByteWonders (hereby referred to as "Service Provider") as a freemium and Ad Supported service. This service is intended for use "AS IS".
</p>
<h2>Information Collection and Use</h2>

<p>The Application collects information when you download and use it. This information may include information such as
</p>
<ul>
<li>  Your device's Internet Protocol address (e.g. IP address)
</li><li> The pages of the Application that you visit, the time and date of your visit, the time spent on those pages
</li><li>The time spent on the Application
</li><li>The operating system you use on your mobile device
</li>
</ul>
<p>The Application does not gather precise information about the location of your mobile device.
</p>
<p>The Application collects your device's location, which helps the Service Provider determine your approximate geographical location and make use of in below ways:
</p>
<ul>
<li>Geolocation Services: The Service Provider utilizes location data to provide features such as personalized content, relevant recommendations, and location-based services.
</li><li>Analytics and Improvements: Aggregated and anonymized location data helps the Service Provider to analyze user behavior, identify trends, and improve the overall performance and functionality of the Application.
</li><li>Third-Party Services: Periodically, the Service Provider may transmit anonymized location data to external services. These services assist them in enhancing the Application and optimizing their offerings.
</li>
</ul>
<p>The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.
</p>
<p>For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information. The information that the Service Provider request will be retained by them and used as described in this privacy policy.
</p>
<h2>Third Party Access</h2>
<p>
Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.
</p>
<p>
Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:
</p>
<ul>
<li>[Google Play Services](https://www.google.com/policies/privacy/)
</li><li>[AdMob](https://support.google.com/admob/answer/6128543?hl=en)
</li>
</ul>
<p>The Service Provider may disclose User Provided and Automatically Collected Information:
</p>
<ul>
<li>as required by law, such as to comply with a subpoena, or similar legal process;
</li><li>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;
</li><li>with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
</li></ul>
<h2>Opt-Out Rights</h2>
<p>
You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
</p>
<h2>Data Retention Policy</h2>
<p>
The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at onebytewonders@gmail.com and they will respond in a reasonable time.
</p>
<h2>Children</h2>

<p> The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
</p>
<p>
The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (onebytewonders@gmail.com) so that they will be able to take the necessary actions.
</p>
<h2>Security</h2>
<p>
The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
</p>
<h2>Changes</h2>
<p>
This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
</p>
<p>
This privacy policy is effective as of 2025-01-20
</p>
<h2>Your Consent</h2>
<p>
By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
</p>
<h2>Contact Us</h2>
<p>
If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at onebytewonders@gmail.com.
</p>
<p>
This privacy policy page was generated by [App Privacy Policy Generator](https://app-privacy-policy-generator.nisrulz.com/)
</p>
 </div>
  )
}

const TermsAndConditions = () => {
  return(
    <div className="document">
    <h1>Terms & Conditions</h1>
<p>
These terms and conditions apply to the Lyric Lab app (hereby referred to as "Application") for mobile devices that was created by OneByteWonders (hereby referred to as "Service Provider") as a freemium and Ad Supported service.
</p>
<p>
Upon downloading or utilizing the Application, you are automatically agreeing to the following terms. It is strongly advised that you thoroughly read and understand these terms prior to using the Application. Unauthorized copying, modification of the Application, any part of the Application, or our trademarks is strictly prohibited. Any attempts to extract the source code of the Application, translate the Application into other languages, or create derivative versions are not permitted. All trademarks, copyrights, database rights, and other intellectual property rights related to the Application remain the property of the Service Provider.
</p>
<p>
The Service Provider is dedicated to ensuring that the Application is as beneficial and efficient as possible. As such, they reserve the right to modify the Application or charge for their services at any time and for any reason. The Service Provider assures you that any charges for the Application or its services will be clearly communicated to you.
</p>
<p>
The Application stores and processes personal data that you have provided to the Service Provider in order to provide the Service. It is your responsibility to maintain the security of your phone and access to the Application. The Service Provider strongly advise against jailbreaking or rooting your phone, which involves removing software restrictions and limitations imposed by the official operating system of your device. Such actions could expose your phone to malware, viruses, malicious programs, compromise your phone's security features, and may result in the Application not functioning correctly or at all.
</p>
<p>
Please note that the Application utilizes third-party services that have their own Terms and Conditions. Below are the links to the Terms and Conditions of the third-party service providers used by the Application:
</p>
<ul>
<li>[Google Play Services](https://policies.google.com/terms)
</li><li>[AdMob](https://developers.google.com/admob/terms)
</li>
</ul>
<p>
Please be aware that the Service Provider does not assume responsibility for certain aspects. Some functions of the Application require an active internet connection, which can be Wi-Fi or provided by your mobile network provider. The Service Provider cannot be held responsible if the Application does not function at full capacity due to lack of access to Wi-Fi or if you have exhausted your data allowance.
</p>
<p>
If you are using the application outside of a Wi-Fi area, please be aware that your mobile network provider's agreement terms still apply. Consequently, you may incur charges from your mobile provider for data usage during the connection to the application, or other third-party charges. By using the application, you accept responsibility for any such charges, including roaming data charges if you use the application outside of your home territory (i.e., region or country) without disabling data roaming. If you are not the bill payer for the device on which you are using the application, they assume that you have obtained permission from the bill payer.
</p>
<p>
Similarly, the Service Provider cannot always assume responsibility for your usage of the application. For instance, it is your responsibility to ensure that your device remains charged. If your device runs out of battery and you are unable to access the Service, the Service Provider cannot be held responsible.
</p>
<p>
In terms of the Service Provider's responsibility for your use of the application, it is important to note that while they strive to ensure that it is updated and accurate at all times, they do rely on third parties to provide information to them so that they can make it available to you. The Service Provider accepts no liability for any loss, direct or indirect, that you experience as a result of relying entirely on this functionality of the application.
</p>
<p>
The Service Provider may wish to update the application at some point. The application is currently available as per the requirements for the operating system (and for any additional systems they decide to extend the availability of the application to) may change, and you will need to download the updates if you want to continue using the application. The Service Provider does not guarantee that it will always update the application so that it is relevant to you and/or compatible with the particular operating system version installed on your device. However, you agree to always accept updates to the application when offered to you. The Service Provider may also wish to cease providing the application and may terminate its use at any time without providing termination notice to you. Unless they inform you otherwise, upon any termination, (a) the rights and licenses granted to you in these terms will end; (b) you must cease using the application, and (if necessary) delete it from your device.
</p>
<h2>Changes to These Terms and Conditions</h2>
<p>
The Service Provider may periodically update their Terms and Conditions. Therefore, you are advised to review this page regularly for any changes. The Service Provider will notify you of any changes by posting the new Terms and Conditions on this page.
</p>
<p>
These terms and conditions are effective as of 2025-01-20
</p>
<h2>Contact Us</h2>
<p>
If you have any questions or suggestions about the Terms and Conditions, please do not hesitate to contact the Service Provider at onebytewonders@gmail.com.
</p>
<p>
This Terms and Conditions page was generated by [App Privacy Policy Generator](https://app-privacy-policy-generator.nisrulz.com/)
</p>
    </div>
  )
}

export default App;
